import template from './sickLeaveQuestion.html';
import controller from './sickLeaveQuestion.controller';
import './sickLeaveQuestion.scss';

let sickLeaveQuestionComponent = {
  restrict: 'E',
  bindings: {
    modalId: '@',
    onSelection: '&',
    isMobileApp: '<',
  },
  template,
  controller
};

export default sickLeaveQuestionComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/sickLeaveQuestion/sickLeaveQuestion.component.js